<!--
/*******************************************************************************
*@ 컴포넌트명   : Product1103001000012ogauc.vue
*@ 컴포넌트설명 : 오클랜드 예금 상품 > 예금 상품 상세(정기적금(사업자용))
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
** 2022.10.06   이가영  오클랜드 금리 변경
** 2022.10.31   이가영  오클랜드 금리 변경
** 2022.12.02   이가영  오클랜드 금리 변경
********************************************************************************/
-->

<template>
  <section class="deposit detail">
    <!--한국어-->
    <template v-if="lang == $config.LANG_KOR">
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>정기적금(사업자용)</h2>
          </div>
          <div class="description">
            <p>매월 일정한 금액을 저축하여 목돈을 마련하는 적립식 상품</p>
          </div>
          <!-- 금리 이율 + 최소가입금액 있을 경우 -->
          <div v-if="true" class="summary">
            <div class="item item-row">
              <div class="tit">
                <span class="exchange-unit">NZD</span>
                <span class="text">최대 연</span>
              </div>
              <div class="percent">5.50%</div>
              <div class="etc">(아래참조)</div>
            </div>
          </div>
          <!--// 금리 이율 + 최소가입금액 있을 경우 end -->
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>상품유형</dt>
            <dd>정기적금</dd>
            <dt>상품개요</dt>
            <dd>매월 일정한 금액을 저축하여 목돈을 마련하는 적립식 상품</dd>
            <dt>가입대상</dt>
            <dd>실명의 법인 및 개인사업자</dd>
            <dt>계약기간</dt>
            <dd>
              최저 1년 ~ 최장 3년(년단위)<br />
              <p style="color:red">12개월 초과 정기예적금 상품은 비대면 채널을 통한 가입이 어려우므로 신규를 원하시는 경우 영업점으로 문의 부탁드립니다.</p>
            </dd>
            <dt>가입통화</dt>
            <dd>NZD</dd>
            <dt>가입금액</dt>
            <dd>신규가입 시 최저 NZD 100.00(약정불입액)</dd>
            <dt>금리 및 이율</dt>
            <dd>약정이율</dd>
          </dl>
          <div class="tbl-top-etc">(연이율, 세전, 단위 : %)</div>
          <table class="table -type02">
            <colgroup>
              <col width="40%" />
              <col width="25%" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row" rowspan="3">정기적금조회</th>
                <th scope="row">1년</th>
                <td>5.50%</td>
              </tr>
              <tr>
                <th scope="row">2년</th>
                <td>4.60%</td>
              </tr>
              <tr>
                <th scope="row">3년</th>
                <td>4.60%</td>
              </tr>
            </tbody>
          </table>
          <div class="info info-type3">
            <p>· 중도해지이율 : 약정이율 x 예금기간별 적용금리</p>
            <p>· 만기후이율 : 약정이율 x ½ (1년 이내) / 약정이율 x 1% (1년 이후)</p>
            <p>· 모든 예금이율은 시장금리상황에 따라 변동이 있을수 있습니다.</p>
          </div>
          <br />
          <div class="info info-type4">
            <strong>수수료</strong>
            <p>
              조기해지수수료
              <br />: 만기 1달전 조기해지시 부과되는 수수료 <br />→ 만기금액 x 조기해지전에치기간(일) x 조기해지이율 / 365 <br />* 조기해지이율 : 약정이율 + 1.5% <br />* 조기해지전
              예치기간(일) = 만기일자 – 조기해지일자
            </p>
          </div>

          <div class="info info-type4">
            <strong>가입방법</strong>
            <p>영업점가입, 인터넷 가입</p>
          </div>
          <div class="info info-type4">
            <strong>가입시 필요서류</strong>
            <p>-대표이사 및 운영권자의 신분증</p>
            <p>-법인단체 정관 등</p>
            <p>※ 기타 자세한 필요서류는 영업점으로 문의하시기 바랍니다.</p>
          </div>
        </article>
      </div>
    </template>

    <!--영어-->
    <template v-else>
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>BUSINESS INSTALLMENT SAVING DEPOSIT</h2>
          </div>
          <div class="description">
            <p>An installment product to build a savings by depositing a fixed amount every month.</p>
          </div>
          <!-- 금리 이율 + 최소가입금액 있을 경우 -->
          <div v-if="true" class="summary">
            <div class="item item-row">
              <div class="tit">
                <span class="exchange-unit">NZD</span>
                <span class="text">Up to</span>
              </div>
              <div class="percent">5.50%</div>
              <div class="etc">p.a. (Refer to information below)</div>
            </div>
          </div>
          <!--// 금리 이율 + 최소가입금액 있을 경우 end -->
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>Types</dt>
            <dd>Installment Savings Account</dd>
            <dt>About the products</dt>
            <dd>An installment product to build a savings by depositing a fixed amount every month.</dd>
            <dt>Eligibilty</dt>
            <dd>Corporations and individual business owners</dd>
            <dt>Contract Terms</dt>
            <dd>
              From 1 year to 3 years (yearly basis)<br />
              <p style="color:red">For enquiries on 12 Months exceed deposit products, please contact the branch.</p>
            </dd>
            <dt>Available currency</dt>
            <dd>NZD</dd>
            <dt>Deposit amount</dt>
            <dd>Minimum NZD 100.00 deposit amount is required. (agreed payment)</dd>
            <dt>Rates</dt>
            <dd>The agreed interest rate</dd>
          </dl>
          <div class="tbl-top-etc">(annual interest rate, pretax, unit : %)</div>
          <table class="table -type02">
            <colgroup>
              <col width="40%" />
              <col width="25%" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row" rowspan="3">Installment Savings Deposit</th>
                <th scope="row">1year</th>
                <td>5.50%</td>
              </tr>
              <tr>
                <th scope="row">2years</th>
                <td>4.60%</td>
              </tr>
              <tr>
                <th scope="row">3years</th>
                <td>4.60%</td>
              </tr>
            </tbody>
          </table>
          <div class="info info-type3">
            <p>· The Midway Break : The agreed interest x of rate equivalent to deposit period</p>
            <p>· After maturity date : The agreed interest x 1/2 (within 1 year) , Over 1 year : 1%</p>
            <p>· All savings interest rates are subject to change according to market interest rate trends.</p>
          </div>
          <br />
          <div class="info info-type4">
            <strong>Fees</strong>
            <p>
              Early termination fee
              <br />: Fee that is charged for early break within 1 month from the maturity <br />→ Total amount at maturity x Day(s) of prematurity x Prematurity Interest / 365
              <br />* Prematurity Interest : Agreed interest rate + 1.5% <br />* Day(s) of prematurity = maturity date – early withdrawal date
            </p>
          </div>

          <div class="info info-type4">
            <strong>How to apply</strong>
            <p>Apply at the branch, Apply Online</p>
          </div>
          <div class="info info-type4">
            <strong>Required documents for application</strong>
            <p>- Directors or Operating Manager's ID</p>
            <p>- Articles of incorporation, etc.</p>
            <p>※ Please contact our branch for more detailed information on required documents.</p>
          </div>
        </article>
      </div>
    </template>
  </section>
</template>
<script>
import { mapFields } from "vuex-map-fields";
export default {
  computed: {
    ...mapFields(["lang"]),
  },
};
</script>
